document.querySelectorAll("[data-ga-track]").forEach(($element) => {
  $element.addEventListener("click", (event) => {
    const trackData = event.currentTarget.dataset.gaTrack.split(";");
    const eventCategory = trackData[2];
    const eventName = trackData[3]; 
    const eventLabel = trackData[4];

    gtag("event", eventName, {
      eventCategory: eventCategory,
      event_label: eventLabel,
    });
  });
});
